const PLANS = {
  1: {
    name: 'A 個人',
    pretaxAmount: '¥120,000',
    tax: '¥12,000',
    totalAmount: '¥132,000',
    desc: 'Plan A 個人（年間）'
  },
  2: {
    name: 'B ベーシック',
    pretaxAmount: '¥600,000',
    tax: '¥60,000',
    totalAmount: '¥660,000',
    desc: 'Plan B ベーシック'
  },
  3: {
    name: 'C ビジネス',
    pretaxAmount: '¥3,600,000',
    tax: '¥360,000',
    totalAmount: '¥3,960,000',
    desc: 'Plan C ビジネス'
  },
  4: {
    name: 'D エンタープライズ',
    pretaxAmount: '¥5,000,000',
    tax: '¥500,000',
    totalAmount: '¥5,500,000',
    desc: 'Plan D エンタープライズ'
  },
  5: {
    name: 'A 個人',
    pretaxAmount: '¥12,000',
    tax: '¥1,200',
    totalAmount: '¥13,200',
    desc: 'Plan A 個人（月間）'
  }
}

const HTTP_STATUS = [
  {
    code: 403,
    message: 'error.code.403'
  },
  {
    code: 404,
    message: 'error.code.404'
  },
  {
    code: 500,
    message: 'error.code.500'
  },
  {
    code: 502,
    message: 'error.code.502'
  },
  {
    code: 504,
    message: 'error.code.502'
  }
]

const WHITE_LIST = [
  '/',
  '/404.html',
  '/fee-plans.html',
  '/login.html',
  '/introduction.html',
  '/show-case.html',
  '/news.html',
  '/report.html',
  '/reset-password.html',
  '/not-found.html'
]

const DASHBOARD_LIST = [
  '/logs.html',
  '/dashboard.html',
  '/enterprise.html',
  '/orders.html',
  '/devices.html',
  '/invitation.html',
  '/payment.html',
  '/admin.html'
]

const MAX_REQ_TIMEOUTS = {
  // max request timeout is 90s
  default: 90 * 1000,
  'auth/login': 10000,
  'webModels/list': 60000,
  'webModels/spaces': 60000,
  'portal/user/list': 60000
}

const VALID_URL = [
  'webModels/share/authorization',
  'webModels/share/link/check',
  'webModels/share/link/legacy',
  'webModels/share/link/checkPassword',
  'webModels/share/authorization'
]

const PREFIX = 'SCANAT_'
const STORAGE_KEY = {
  LOGIN_TIME: PREFIX + 'LOGIN_TIME',
  REDIRECT_URL: PREFIX + 'REDIRECT_URL'
}

export { PLANS, HTTP_STATUS, WHITE_LIST, MAX_REQ_TIMEOUTS, STORAGE_KEY, DASHBOARD_LIST, VALID_URL }
